import { ReactNode } from 'react';
import FormLabel from './FormLabel';

type Props = {
  id?: string;
  label?: string;
  error?: string;
  children: ReactNode;
};

/**
 * The label / control / error wrapper every field shares.
 *
 * The error is tied to the control with aria-describedby by the fields themselves —
 * this only renders it. Kept in one place so a fix to the error styling or the aria
 * wiring does not have to be made three times.
 */
export default function FormField({ id, label, error, children }: Props) {
  return (
    <div className="flex flex-col mb-5">
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}
      {children}
      {error && (
        <span id={id ? `${id}-error` : undefined} className="text-red-600 text-sm mt-1">
          {error}
        </span>
      )}
    </div>
  );
}
